import { useEffect, useState } from "react";
import api from "../../lib/api";
import { CardGrid, CardDetailDialog } from "./MyCards";

export default function AllCards() {
  const [cards, setCards] = useState([]);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/admin/generated-cards").then((r) => setCards(r.data.cards)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-accent">CITIDAN Staff</div>
        <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">All Cards</h1>
        <p className="mt-2 text-sm text-muted-foreground">Every generated card across all merchants ({cards.length}).</p>
      </div>
      <CardGrid cards={cards} onView={setDetail} showOwner />
      <CardDetailDialog card={detail} onClose={() => setDetail(null)} />
    </div>
  );
}
